
import React, { Component } from 'react';
import axios from 'axios';
import _ from 'lodash';
import { Field } from 'redux-form';
import classNames from 'classnames';
import { SubmissionError } from 'redux-form';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Form, DropdownButton, MenuItem, InputGroup, Input } from 'react-bootstrap';
import Spinner from '../../components/Widgets/spinner';
import InputField from '../Common/inputField';
import Selection from '../Common/selection'
import { Translate, Localize } from 'react-redux-i18n';

class CustomerInfo extends Component {
    componentDidMount() {
      this.props.fetchCustomers();
    }

    handleFormSubmit(formProps) {
      if(!this.checkPermission("add_purchase_order")) {
        let Deliver_Customer_id = formProps.Deliver_Customer_id.value;
        let Deliver_CustomerDetail_id = formProps.CustomerDetail_id.value, PaymentTerm_id = -1;
        const index = _.findIndex(this.props.customers, { 'Customer_id': Deliver_Customer_id });
        if(index > -1 && this.props.customers[index]) {
          PaymentTerm_id = this.props.customers[index].PaymentTerm_id
        }
        this.props.createDropship(Deliver_Customer_id, Deliver_CustomerDetail_id, PaymentTerm_id, this.props.orderInfo, this.props.orderLineInfo, this.props.totalNetWeight, this.props.totalShippingWeight, this.props.totalPrice, this.props.finalPrice);
      }
      else
        alert("You have no permission!");
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.deliver_Customer_id && nextProps.deliver_Customer_id != this.props.deliver_Customer_id) {
          this.props.fetchCustomerDetail(nextProps.deliver_Customer_id.value);
        }
    }

    renderCustomers() {
        if (this.props.customersIsLoading) return <Spinner/> // If payment term is loading, show a spinner.
        else {
            let customerNameOptions = this.getCustomerNameOptions();
            let customerNumOptions = this.getCustomerNumOptions();
            return (
                <div>
                    <Row className="mb-lg">
                      <Col sm={ 12 }>
                        <label className="col-sm-3"><Translate value="customer_name" />:</label>
                        <Col sm={ 4 }><Field name="Deliver_Customer_id" component={Selection} options={customerNameOptions }/></Col>
                      </Col>
                    </Row>
                    <Row className="mb-lg">
                      <Col sm={ 12 }>
                        <label className="col-sm-3"><Translate value="customer_no" />:</label>
                        <Col sm={ 4 }><Field name="Deliver_Customer_id" component={Selection} options={customerNumOptions}/></Col>
                      </Col>
                    </Row>
                </div>
            )
        }
    }

    renderCustomerShippingAddress() {
      if (this.props.detailIsLoading) return <Spinner/> // If payment term is loading, show a spinner.
      else {
          let customerShippingAddressOptions = this.getCustomerShippingAddressOptions();
          return (
              <div>
                <Row className="mb-lg">
                  <Col sm={ 12 }>
                    <label className="col-sm-3"><Translate value="shipping_address" />:</label>
                    <Col sm={ 9 }><Field name="CustomerDetail_id" component={Selection} options={ customerShippingAddressOptions }/></Col>
                  </Col>
                </Row>
              </div>
          )
      }
    }

    getCustomerNameOptions() {
        var customerOptions = [];
        this.props.customers.map(customer => {
            customerOptions.push({ value: customer.Customer_id, label: customer.Name })
        });
        return customerOptions;
    }

    getCustomerNumOptions() {
        var customerOptions = [];
        this.props.customers.map(customer => {
            customerOptions.push({ value: customer.Customer_id, label: customer.CustomerNum })
        });
        return customerOptions;
    }

    getCustomerShippingAddressOptions() {
      var customerShippingAddressOptions = [];
      if(this.props.currentCustomerDetail && this.props.currentCustomerDetail.Shipping) {
        this.props.currentCustomerDetail.Shipping.map(shipping => {
            let address;
            address = shipping.Street + " " + shipping.City + " " + shipping.State + " " + shipping.Zip;
            customerShippingAddressOptions.push({ value: shipping.CustomerDetail_id, label: address })
        });
      }
      return customerShippingAddressOptions;
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        const { handleSubmit, closeShowCustomer, submitting, pristine, valid } = this.props;
        return (
            <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
                <Row>
                  <Col xs={ 12 }>
                    { this.renderCustomers() }
                  </Col>
                </Row>
                <Row>
                  <Col xs={ 12 }>
                    { this.renderCustomerShippingAddress() }
                  </Col>
                </Row>
                <ButtonToolbar className="mt-xl">
                  <Button bsStyle="success" type="submit" disabled={ submitting || pristine } >
                    <em className="fa fa-save" /><Translate value="save" />
                  </Button>
                  <Button bsStyle="danger" type="cancel" onClick={(event) => { event.preventDefault(); closeShowCustomer(); } } >
                    <em className="fa fa-close" /><Translate value="cancel" />
                  </Button>
                </ButtonToolbar>
                { this.props.isCreating || this.props.isEditing && <Spinner/> }
                { this.props.createError && <div className="alert alert-danger marginTopStyle">{JSON.stringify(this.props.createError)}</div> }
                { this.props.editError && <div className="alert alert-danger marginTopStyle">{JSON.stringify(this.props.editError)}</div> }
            </form>
        )
    }
}

export default CustomerInfo



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/customerInfo.jsx